<template>
  <v-container fluid id="fcreate">
    <Breadcrumbs/>
    <h1 class="mb-1 text-h2">
      Создать акцию
    </h1>
    <v-row>
      <v-form v-model="valid" ref="form" @submit.prevent="submit">
        <v-container fluid>
          <v-row>
            <!-- Название -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.name"
                label="Название"
                outlined
                required
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <v-col cols="12" md="7">
              <regions-select-fields
                v-model="data.regions"
                label="Доступно в регионах"
                empty-text="Доступно во всех регионах"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <v-col cols="12" md="7">
              <regions-select-fields
                v-model="data.regionsExclude"
                label="Не доступно в регионах"
                empty-text="Нет исключенных регионов"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Подзаголовок -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.sub_name"
                label="Заголовок в личном кабинете"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Slug -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.slug"
                label="URL"
                outlined
                required
                :rules="rules.slug"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Цвет фона картинки -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.imgBgrColor"
                label="Цвет фона картинки"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Изображение -->
            <v-col cols="12" md="7">
              <upload-image
                v-model="data.image"
                color="blue"
                label="Загрузить"
              >
                <v-icon
                  left
                  v-text="`mdi-plus`"
                />
                Картинка
              </upload-image>
            </v-col>
            <v-col cols="12" md="7">
              <upload-image
                v-model="data.mobileImage"
                color="blue"
                label="Загрузить фото"
              >
                <v-icon
                  left
                  v-text="`mdi-plus`"
                />
                Мобильная картинка
              </upload-image>
            </v-col>
            <!-- Описание -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.description"
                label="Описание в личном кабинете"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Текст над промокодом -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.textOne"
                label="Текст над промокодом"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Промокод -->
            <v-col cols="12" md="7">
              <v-autocomplete
                v-model="data.promoCodeId"
                :items="orders"
                item-text="name"
                item-value="id"
                label="Промокод"
                clearable
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Текст под промокодом -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.textTwo"
                label="Текст под промокодом"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Тег h1 -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.h1"
                label="H1 (заголовок страницы)"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Мета заголовок -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.metaTitle"
                label="Meta title"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Мета Описание -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.metaDescription"
                label="Meta description"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Дата начала -->
            <v-col cols="12" md="7">
              <!-- ДАТА -->
              <v-menu
                v-model="data.dateBegin.menu"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="computedTimeOnDateFormattedMomentjs"
                    clearable
                    label="Дата начала"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="data.dateBegin.date = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="data.dateBegin.date"
                  @change="data.dateBegin.menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- Дата конца -->
            <v-col cols="12" md="7">
              <!-- ДАТА -->
              <v-menu
                v-model="data.dateEnd.menu"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="computedTimeEndDateFormattedMomentjs"
                    clearable
                    label="Дата конца"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="data.dateEnd.date = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="data.dateEnd.date"
                  @change="data.dateEnd.menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- Сортировка -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.sortOrder"
                label="Сортировка"
                outlined
                required
                :rules="rules.requiredNumber"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Submit -->
            <v-col cols="12" md="7">
              <v-row>
                <v-col md="6">
                  <v-btn
                    block
                    large
                    :loading="loading"
                    :disabled="loading"
                    @click.prevent="$router.push('/promotions')"
                  >
                    Отмена
                  </v-btn>
                </v-col>
                <v-col md="6">
                  <v-btn
                    block
                    class="mb-2"
                    large
                    color="success"
                    :loading="loading"
                    :disabled="loading"
                    type="submit"
                  >
                    Создать
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  import UploadImage from './../../components/UploadImage'
  import rules from '@/mixins/rules'
  import RegionsSelectFields from '@/components/ui/crud/fields/RegionsSelectField.vue'
  import snackbarMessage from '@/mixins/snackbar-message'

  export default {
    mixins: [rules, snackbarMessage],
    components: { UploadImage, RegionsSelectFields },
    data () {
      return {
        data: {
          promoCodeId: '',
          name: '',
          sub_name: '',
          slug: '',
          image: '',
          description: '',
          h1: '',
          metaTitle: '',
          metaDescription: '',
          imgBgrColor: '',
          textOne: '',
          textTwo: '',
          dateBegin: {
            menu: false,
            date: '',
          },
          dateEnd: {
            menu: false,
            date: '',
          },
          sortOrder: 100,
          status: true,
          regions: [],
          regionsExclude: [],
        },
        valid: false,
        loading: false,
        snackbar: false,
      }
    },
    computed: {
      ...mapState('promocodes', ['orders']),
      computedTimeOnDateFormattedMomentjs () {
        return this.data.dateBegin.date ? moment(this.data.dateBegin.date).format('YY-MM-DD') : ''
      },
      computedTimeEndDateFormattedMomentjs () {
        return this.data.dateEnd.date ? moment(this.data.dateEnd.date).format('YY-MM-DD') : ''
      },
    },
    async created () {
      await this.$store.dispatch('promocodes/fetchPromocodesList', {
        limit: 10000,
        offset: 0,
        page: 0,
      })
    },
    methods: {
      async submit () {
        const validate = await this.$refs.form.validate()

        if (validate) {
          this.loading = true

          try {
            const data = this.data

            data.dateBegin = data.dateBegin.date
            data.dateEnd = data.dateEnd.date

            const res = await this.$store.dispatch('promotions/createPromotions', data)
            if (res.status === 200) this.$router.push('/promotions')
          } catch (e) {
            this.showErrorFromResponse(e)
          }

          this.loading = false
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
      resetActionSettings () {
        this.data.salePercent = null
        this.data.saleSubtraction = null
      },
    },
  }
</script>
